import { useEffect, useState } from "react";

// Helpers
import { accountFormat } from "@Common/helpers/number";

// MUI
import { Typography } from "@mui/material";

const INCREMENT_PERCENTAGE = 0.05;
const INTERVAL_TIME_MS = 3;

interface AnimatedNumberProps {
	finalValue: number;
}

export const AnimatedNumber = ({ finalValue }: Readonly<AnimatedNumberProps>) => {
	const [currentValue, setCurrentValue] = useState(0);

	useEffect(() => {
		const intervalId = setInterval(() => {
			setCurrentValue((prevValue) => {
				const diff = finalValue - prevValue;
				// Increment by x% of remaining value
				const increment = Math.max(1, Math.floor(Math.abs(diff) * INCREMENT_PERCENTAGE));
				const newValue = prevValue + (diff > 0 ? increment : -increment);

				if (Math.abs(finalValue - newValue) <= 1) {
					// Tolerance due to increment
					clearInterval(intervalId);
					return finalValue; // Ensure the final value is set correctly
				}

				return newValue;
			});
		}, INTERVAL_TIME_MS); // You may need to adjust the delay to control the speed

		return () => clearInterval(intervalId); // Clear timeout on unmount
	}, [finalValue]);

	return (
		<Typography variant="body1" component="span" sx={{ fontSize: "30px", fontFamily: "Montserrat", fontWeight: 600 }}>
			{accountFormat(currentValue, 0)}
		</Typography>
	);
};
